import { render } from "./JobPosterIndex.vue?vue&type=template&id=6745d902"
import script from "./JobPosterIndex.vue?vue&type=script&lang=js"
export * from "./JobPosterIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__